import { render, staticRenderFns } from "./MenuItemMobile.vue?vue&type=template&id=89d475d0&lang=pug&"
import script from "./MenuItemMobile.vue?vue&type=script&lang=js&"
export * from "./MenuItemMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports